// src/components/ui/CountryFlag.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import React from 'react';
import { getFlag } from 'utils/phone';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const BASE_STYLE = { objectFit: 'cover', borderRadius: 2 };

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
// CountryFlag - Renders country flag as SVG img
const CountryFlag = ({ countryCode, style = {}, size = 24 }) => {
  const src = getFlag(countryCode);

  if (!src) return null;

  return (
    <img
      src={src}
      alt={countryCode}
      style={{ width: size, height: size * 0.67, ...BASE_STYLE, ...style }}
      onError={e => { e.target.style.display = 'none'; }}
    />
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CountryFlag;
